import _ from "lodash";
import React from "react";
import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";

export const RsDatePicker = React.forwardRef(
    (
        {
            label,
            id,
            name,
            placeholder = "Select date",
            disabled = false,
            required = false,
            isHideLabel = false,
            className = "",
            subTitle = "",
            subRequired = false,
            errors = null,
            errorName = "",
            value,
            onChange,
            format = "dd-MM-yyyy",
            minDate = null,
            maxDate = null,
            shouldDisableDate = null,
            disablePastDates = false,
            disableFutureDates = false,
            disabledDates = [],
            ...props
        },
        ref
    ) => {
        const msg = _.get(errors || {}, errorName || name);
        const uniqueId = React.useId();
        const pickerClassName = `custom-rs-datepicker-${uniqueId}`;
        // Combined disable date function
        const handleDisableDate = (date) => {
            // Custom function takes priority
            if (shouldDisableDate && shouldDisableDate(date)) {
                return true;
            }

            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const checkDate = new Date(date);
            checkDate.setHours(0, 0, 0, 0);

            // Disable past dates
            if (disablePastDates && checkDate < today) {
                return true;
            }

            // Disable future dates
            if (disableFutureDates && checkDate > today) {
                return true;
            }

            // Check min date
            if (minDate) {
                const min = new Date(minDate);
                min.setHours(0, 0, 0, 0);
                if (checkDate < min) {
                    return true;
                }
            }

            // Check max date
            if (maxDate) {
                const max = new Date(maxDate);
                max.setHours(0, 0, 0, 0);
                if (checkDate > max) {
                    return true;
                }
            }

            // Check specific disabled dates
            if (disabledDates && disabledDates.length > 0) {
                const isDisabled = disabledDates.some(disabledDate => {
                    const d = new Date(disabledDate);
                    d.setHours(0, 0, 0, 0);
                    return d.getTime() === checkDate.getTime();
                });
                if (isDisabled) {
                    return true;
                }
            }

            return false;
        };

        return (
            <div className="w-full font-urbanist">
                {(!!label || !isHideLabel) && (
                    <label
                        htmlFor={id}
                        className={`block text-lg font-semibold mb-1 ${disabled ? "text-gray-500" : "text-white"}`}
                    >
                        {label} {required && <span className="text-red-600">*</span>}
                    </label>
                )}
                {
                    !!subTitle &&
                    <p className="text-xs text-gray-400 mb-1">
                        {subTitle}
                        {subRequired && <span className="text-red-600">*</span>}
                    </p>
                }
                <DatePicker
                    ref={ref}
                    id={id}
                    oneTap={true}
                    name={name}
                    value={value}
                    onChange={onChange}
                    format={format}
                    placeholder={placeholder}
                    disabled={disabled}
                    block
                    className={`${pickerClassName} ${className}`}
                    shouldDisableDate={handleDisableDate}
                    style={{ width: '100%' }}
                    {...props}
                />
                {
                    !!msg &&
                    <div className="text-red-700 text-sm md:text-md mt-2">{msg}</div>
                }
                <style jsx="true" global="true">{`

                    :root{
                        --rs-input-bg: #22262E;
                        --rs-bg-overlay: #22262E;
                        --rs-border-primary: rgb(55 65 81 / var(--tw-border-opacity, 1));
                        --rs-focus-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
                        --rs-input-focus-border: rgb(255 255 255 / var(--tw-ring-opacity, 1));
                        --rs-text-primary: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-btn-subtle-text: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-text-secondary: rgb(107 114 128 / var(--tw-text-opacity, 1));
                        --rs-calendar-cell-selected-hover-bg: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-btn-primary-hover-bg: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-bg-active: #ffffff;
                        --rs-calendar-date-selected-text: #22262E;
                        --rs-listbox-option-hover-bg: rgb(55 65 81 / var(--tw-border-opacity, 1));
                        --rs-listbox-option-hover-text: #ffffff;
                        --rs-btn-primary-text: #22262E;
                        --rs-btn-primary-bg: var(--rs-gray-0);
                        --rs-btn-primary-border-color: var(--rs-gray-0);
                        --rs-btn-link-hover-text: rgb(255 255 255 / var(--tw-ring-opacity, 0.6));
                        --rs-btn-link-text: #ffffff;
                        --rs-input-disabled-bg: #22262E;
                    }

                    
                `}</style>
            </div>
        )
    }
);